/*
 * The Diabetes Vibe — lightweight event layer (no dependencies).
 * Publishes named events to:
 *   1. Shopify.analytics.publish  → available to Customer Events custom pixels (GA4 etc.)
 *   2. window.dataLayer           → available to GTM if ever installed
 * Event names are documented in docs/04-ANALYTICS-EVENTS.md. Keep them stable.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function track(name, data) {
    var payload = Object.assign({ page_type: document.body.dataset.tdvPageType || '', page_path: location.pathname }, data || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('tdv_' + name, payload);
      }
    } catch (e) { /* never break the page for analytics */ }
    window.dataLayer.push(Object.assign({ event: 'tdv_' + name }, payload));
  }
  window.tdvTrack = track;

  // 1) Email form views (once per form, when 50% visible)
  var forms = document.querySelectorAll('[data-tdv-form]');
  if ('IntersectionObserver' in window && forms.length) {
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          track('email_form_view', { form_source: entry.target.dataset.tdvForm });
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    forms.forEach(function (f) { io.observe(f); });
  }

  // 2) Email form submissions (attempt) + remember source for success event
  document.addEventListener('submit', function (e) {
    var wrap = e.target.closest('[data-tdv-form]');
    if (!wrap) return;
    var source = wrap.dataset.tdvForm;
    track('email_form_submit', { form_source: source, lead_magnet: wrap.dataset.tdvLeadMagnet || '' });
    try { sessionStorage.setItem('tdv_last_form', source + '|' + (wrap.dataset.tdvLeadMagnet || '')); } catch (err) {}
  }, true);

  // 3) Successful signup (Shopify redirects with ?customer_posted=true)
  if (/[?&]customer_posted=true/.test(location.search)) {
    var last = '';
    try { last = sessionStorage.getItem('tdv_last_form') || ''; sessionStorage.removeItem('tdv_last_form'); } catch (err) {}
    var parts = last.split('|');
    track('email_signup', { form_source: parts[0] || 'unknown', lead_magnet: parts[1] || '' });
    if (parts[1]) track('lead_magnet_signup', { lead_magnet: parts[1] });
  }

  // 4) Clicks: CTAs, upsells, lead-magnet downloads, affiliate / outbound links
  document.addEventListener('click', function (e) {
    var el = e.target.closest('a, button');
    if (!el) return;
    var ev = el.dataset.tdvEvent;
    if (ev) {
      track(ev, { label: el.dataset.tdvLabel || (el.textContent || '').trim().slice(0, 80), destination: el.getAttribute('href') || '' });
    }
    if (el.tagName === 'A' && el.href) {
      var rel = (el.getAttribute('rel') || '').toLowerCase();
      var external = el.hostname && el.hostname !== location.hostname;
      if (rel.indexOf('sponsored') > -1 || el.dataset.tdvAffiliate !== undefined) {
        track('affiliate_click', { destination: el.href, label: el.dataset.tdvLabel || (el.textContent || '').trim().slice(0, 80) });
      } else if (external && !ev) {
        track('outbound_click', { destination: el.href });
      }
    }
  });

  // 5) Article read depth (75%) — content engagement signal
  var body = document.querySelector('[data-tdv-article-body]');
  if (body && 'IntersectionObserver' in window) {
    var marker = document.createElement('span');
    marker.setAttribute('aria-hidden', 'true');
    var kids = body.children;
    if (kids.length > 3) {
      kids[Math.floor(kids.length * 0.75)].before(marker);
      var mo = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          track('article_read_75', { article: body.dataset.tdvArticleBody, category: body.dataset.tdvCategory || '' });
          mo.disconnect();
        }
      });
      mo.observe(marker);
    }
  }

  // 6) Print recipe button
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tdv-print]')) { e.preventDefault(); track('recipe_print'); window.print(); }
  });
})();
